import * as React from 'react';
import cn from '~modules/cn';

import './form-label.scss';

type FormLabelProps = {
    children: React.ReactNode;
    disabled?: boolean;
    required?: boolean;
};

type Props = React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & FormLabelProps;

const FormLabel = ({ className, disabled, required, children, ...props }: Props): JSX.Element => (
    <label {...props} className={cn('form-label', { 'form-label--disabled': disabled, 'form-label--required': required }, className)}>
        {children}
    </label>
);

FormLabel.displayName = 'FormLabel';

export default FormLabel;
